import React from 'react';
import { PricingCalculation, PricingValidationService } from '../../services/pricingValidationService';

interface PricingCalculatorDisplayProps {
  calculation?: PricingCalculation;
  className?: string;
}

const PricingCalculatorDisplay: React.FC<PricingCalculatorDisplayProps> = ({
  calculation,
  className = ''
}) => {
  if (!calculation || !calculation.isValidCombination) {
    return null;
  }

  const display = PricingValidationService.generatePricingDisplay(calculation);

  return (
    <div className={`pricing-calculator-display ${className}`}>
      <div className="pricing-preview">
        <div className="pricing-preview-header">
          <i className="bi bi-calculator"></i>
          <span>Pricing Preview</span>
        </div>
        
        {calculation.displayFormat === 'single' ? (
          <div className="single-price">
            <div className="price-label">Project Price:</div>
            <div className="price-value">{display.originalPriceText}</div>
          </div>
        ) : (
          <div className="comparison-pricing">
            <div className="original-price">
              <div className="price-label">Original Price:</div>
              <div className="price-value original">{display.originalPriceText}</div>
            </div>
            
            <div className="discount-arrow">
              <i className="bi bi-arrow-right"></i>
              <span className="discount-percent">{calculation.discountPercent}% off</span>
            </div>
            
            <div className="discounted-price">
              <div className="price-label">Early Bird Price:</div>
              <div className="price-value discounted">{display.discountedPriceText}</div>
            </div>
            
            <div className="savings-highlight">
              <i className="bi bi-piggy-bank"></i>
              <span>Save {display.savingsText}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PricingCalculatorDisplay;